function hay(message: string): string {
  return message.toLowerCase();
}

/** Kayıt API hatalarını kullanıcıya Türkçe gösterir; ham İngilizce metin sızmaz. */
export function signupErrorMessage(status: number, message: string): string {
  const m = hay(message);
  if (status === 403 && m.includes('captcha')) return 'Robot doğrulaması geçersiz veya süresi doldu. Kutuyu yeniden işaretleyip tekrar deneyin.';
  if (status === 422 || m.includes('already exists')) return 'Bu e-posta ile zaten hesap var. Giriş yapmayı deneyin.';
  if (status === 400 && m.includes('email')) return 'Geçerli bir e-posta adresi yazın.';
  if (m.includes('password too short')) return 'Şifre en az 8 karakter olmalı.';
  return 'Kayıt yapılamadı. Bilgilerinizi kontrol edip tekrar deneyin.';
}

/** Giriş API hatalarını ayırır: captcha 403 ile doğrulanmamış e-posta 403 karışmasın. */
export function loginErrorMessage(status: number, message: string): string {
  const m = hay(message);
  if (status === 403 && m.includes('captcha')) return 'Robot doğrulaması geçersiz veya süresi doldu. Kutuyu yeniden işaretleyip tekrar deneyin.';
  if (status === 403 && m.includes('not verified')) return 'E-posta adresinizi henüz doğrulamadınız. Gelen kutunuzu kontrol edin.';
  return 'E-posta veya şifre hatalı.';
}
